import { Dialog, DialogFooter, DialogType, IDialogContentProps, PrimaryButton } from '@fluentui/react';
import React from 'react';
import { fontFamily } from '../../../../app-core/app-theme';

interface IIncludedServicesPanelProps {
  includedServices: string[] | null | undefined;
  onClose: () => void;
}

const dialogContentProps: IDialogContentProps = {
  type: DialogType.largeHeader,
  title: 'Included At No Additional Cost',
};

const modalProps = {
  isBlocking: false,
  styles: { main: { fontFamily: fontFamily, '@media (min-width: 480px)': { width: '50%', minWidth: 340, maxWidth: 650 }} },
};

export const IncludedServicesPanel: React.FunctionComponent<IIncludedServicesPanelProps> = (props) => {
  const includedServices = props.includedServices ?? [];

  return (
    <Dialog
      hidden={!props.includedServices}
      onDismiss={props.onClose}
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
    >
      <ul>
        {includedServices.map(service =>
          <li>{service}</li>
        )}
      </ul>
      <DialogFooter>
        <PrimaryButton onClick={props.onClose} text="Got it" />
      </DialogFooter>
    </Dialog>
  );
};
